// External Dependencies:
import React from 'react'
import { Link } from 'react-router-dom'

// Internal Dependencies:
import { getUrlParameter } from 'utilities/url'

class Testimonial extends React.Component {
	render() {
		if ( ! siteData.testimonial ) {
			return null
		}

		return (
			<section className="testimonial">
				<div className="-inner">
					<div className="-text">
						<h3 dangerouslySetInnerHTML={ { __html: siteData.testimonial.heading } } />

						<cite>{ siteData.testimonial.cite }</cite>
					</div>

					<div className="-bg">
						<img src={ siteData.testimonial.image_url } alt="" />
					</div>
				</div>
			</section>
		)
	}
}

export default Testimonial
